export const EDIT_ASSET_LENGTH_OPTIONS: string[] = ['6"', '15"', '30"', '45"', '60"', '90+"'];

export const EDIT_ASSET_FORMAT_OPTIONS: string[] = ['H 16:9', 'V 9:16', 'V 4:5', 'S 1:1'];

export const EDIT_ASSET_BETS_OPTIONS: string[] = [
  'TVC',
  'YOUTUBE',
  'META',
  'TIKTOK',
  'SNAPCHAT',
  'OOH',
  'PRINT',
  'ECOM',
  'WEBSITE',
  'MERCH',
];

export const EDIT_ASSET_FORMAT_DISPLAY_MAP: Record<
  string,
  {
    type: string;
    ratio: string;
  }
> = {
  'H 16:9': { type: 'HORIZONTAL', ratio: '16:9' },
  'V 9:16': { type: 'VERTICAL', ratio: '9:16' },
  'V 4:5': { type: 'VERTICAL', ratio: '4:5' },
  'S 1:1': { type: 'SQUARE', ratio: '1:1' },
};

export const TECHNICAL_VARIANT_ASSET_TYPE: string = 'TECHNICAL_VARIANT';
export const MASTER_ASSET_TYPE: string = 'MASTER';

export const DEFAULT_ASSET_FOCUS: string = 'HERO';
export const DEFAULT_ASSET_TYPE: string = 'HERO VIDEO';

export const LENGTH_STATUS_SHORT: string = 'SHORT';
export const LENGTH_STATUS_MEDIUM: string = 'MEDIUM';
export const LENGTH_STATUS_LONG: string = 'LONG';

export const LENGTH_STATUS_THRESHOLDS: Record<string, number> = {
  SHORT_MAX: 10,
  MEDIUM_MAX: 29,
};

export const LENGTH_MIN_SECONDS: number = 1;
export const LENGTH_MAX_SECONDS: number = 90;
